import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridOptions, GridReadyEvent } from 'ag-grid';
import { Subscription } from 'rxjs';
import { CountyService } from '../../services/county.service';
import { SweetAlertHelper } from '../../core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-county',
  templateUrl: './county.component.html',
  styleUrls: ['./county.component.scss'],
})
export class CountyComponent implements OnInit, OnDestroy {
  gridCounty: GridOptions;
  activeAdd = false;
  enabledBtn = false;
  isactive: boolean;
  countySelected: any = {};
  subscriptions: Subscription[] = [];

  constructor(
    protected toastrAlertHelper: ToastrAlertHelper,
    private _serviceCountyService: CountyService,
    private sweetAlertHelper: SweetAlertHelper
  ) {
    this.initGrid();
  }

  ngOnInit() {}

  initGrid() {
    this.gridCounty = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          headerName: 'Description',
          field: 'description',
          colId: 'description',
          width: 300,
        },
        {
          colId: 'deleteRow',
          cellRenderer: () => {
            return "<span <i class='fa fa-trash-o' style='color: red; cursor: pointer;' aria-hidden='true'></i></span>";
          },
          width: 50,
        },
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event) {
          this.getData();
          this.gridCounty.api.sizeColumnsToFit();
        }
      },
    };
  }

  selectCounty(params: any) {
    if (params.colDef.colId === 'deleteRow') {
      this.sweetAlertHelper
        .createCustomAlert({
          title: 'Are You Sure',
          text: `Disabled this county ${params.data.description}?`,
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#FF0000',
          confirmButtonText: 'Delete',
        })
        .then((result) => {
          if (result.value) {
            this.deleteCounty(params.data.countyid);
          }
        });
    }
  }

  selectDeleteRow() {
    const selectedTrips = [];
    this.gridCounty.api.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        selectedTrips.push(node.data);
      }
    });
    if (selectedTrips.length > 0) {
      this.sweetAlertHelper
        .createCustomAlert({
          title: 'Are you sure?',
          text: `Disable this county ${selectedTrips[0].description}?`,
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        })
        .then((result) => {
          if (result.value) {
            this.deleteCounty(selectedTrips[0].countyid);
          }
        });
    }
  }

  deleteCounty(countyid: number) {
    this.subscriptions.push(
      this._serviceCountyService.deleteCounty(countyid).subscribe(
        (resp: any) => {
          if (resp) {
            this.sweetAlertHelper
              .createCustomAlert({
                title: 'Success',
                text: resp.message,
                type: 'success',
              })
              .then(() => {
                this.getData();
              });
          }
        },
        (error) => this.sweetAlertHelper.captureException(error)
      )
    );
  }

  editCounty() {
    const tem = this.gridCounty.api.getSelectedRows()[0];
    if (tem) {
      this.countySelected = tem;
      this.activeAdd = true;
      this.enabledBtn = true;
    }
  }

  addNewCounty() {
    this.countySelected = null;
    this.changeActiveAdd();
  }

  changeActiveAdd() {
    this.activeAdd = !this.activeAdd;
    this.enabledBtn = !this.enabledBtn;
  }

  getData() {
    this.subscriptions.push(
      this._serviceCountyService.getCountys().subscribe(
        (data) => {
          const filter = this.gridCounty.api.getFilterModel();
          this.gridCounty.api.setRowData(data);
          Object.keys(filter).length
            ? this.gridCounty.api.setFilterModel(filter)
            : this.onChangeActive(this.isactive);
        },
        (error) => this.sweetAlertHelper.captureException(error)
      )
    );
  }

  onChangeActive(show: boolean) {
    if (!show) {
      this.gridCounty.api.setFilterModel({
        isactive: { values: ['true', ''], filterType: 'set' },
      });
    } else {
      this.gridCounty.api.setFilterModel({
        isactive: { values: ['true', 'false'], filterType: 'set' },
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/county/county.component.ts